'use client';
import React, { useState } from 'react';
import WizardTopBar from './WizardTopBar';
import WizardProgressBar from './WizardProgressBar';
import Step1Welcome from './Step1Welcome';
import Step2VisaSelection from './Step2VisaSelection';
import Step3PersonalInfo from './Step3PersonalInfo';
import Step4Requirements from './Step4Requirements';
import Step5DocumentUpload from './Step5DocumentUpload';
import Step6Validation from './Step6Validation';
import Step7Generation from './Step7Generation';
import Step8Download from './Step8Download';
import Step9Payment from './Step9Payment';

export interface WizardData {
  language: string;
  travelPurpose: string;
  destinationCountry: string;
  destinationFlag: string;
  visaType: string;
  fullName: string;
  nationality: string;
  passportNumber: string;
  travelDuration: string;
  travelDate: string;
  sponsorType: string;
  hasTravelHistory: boolean;
  travelHistoryDetails: string;
}

const defaultData: WizardData = {
  language: 'en',
  travelPurpose: '',
  destinationCountry: '',
  destinationFlag: '',
  visaType: '',
  fullName: '',
  nationality: '',
  passportNumber: '',
  travelDuration: '',
  travelDate: '',
  sponsorType: 'self',
  hasTravelHistory: false,
  travelHistoryDetails: '',
};

const TOTAL_STEPS = 9;

export default function VisaWizard() {
  const [currentStep, setCurrentStep] = useState(1);
  const [wizardData, setWizardData] = useState<WizardData>(defaultData);

  const updateData = (partial: Partial<WizardData>) => {
    setWizardData((prev) => ({ ...prev, ...partial }));
  };

  const next = () => setCurrentStep((s) => Math.min(s + 1, TOTAL_STEPS));
  const back = () => setCurrentStep((s) => Math.max(s - 1, 1));
  const goTo = (step: number) => setCurrentStep(step);

  const stepProps = { data: wizardData, updateData, onNext: next, onBack: back };

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50/40 to-white flex flex-col">
      <WizardTopBar currentStep={currentStep} totalSteps={TOTAL_STEPS} onGoTo={goTo} />
      <WizardProgressBar currentStep={currentStep} totalSteps={TOTAL_STEPS} />

      <main className="flex-1 flex items-start justify-center px-4 py-8 lg:py-12">
        <div className="w-full max-w-2xl xl:max-w-3xl">
          {currentStep === 1 && <Step1Welcome {...stepProps} />}
          {currentStep === 2 && <Step2VisaSelection {...stepProps} />}
          {currentStep === 3 && <Step3PersonalInfo {...stepProps} />}
          {currentStep === 4 && <Step4Requirements {...stepProps} />}
          {currentStep === 5 && <Step5DocumentUpload {...stepProps} />}
          {currentStep === 6 && <Step6Validation {...stepProps} />}
          {currentStep === 7 && <Step7Generation {...stepProps} />}
          {currentStep === 8 && <Step8Download {...stepProps} />}
          {currentStep === 9 && <Step9Payment {...stepProps} />}
        </div>
      </main>
    </div>
  );
}